module.exports = __webpack_public_path__ + "static/media/Releated1.07cbb28a.png";